import React from 'react';
import { Text, Link } from '@chakra-ui/react';
import { externalLinks } from 'app/api.config';

export const VisitSessionLink = () => (
  <Text
    marginLeft="auto"
    color="white"
    fontSize="sm"
    fontWeight={500}
    lineHeight="small"
    paddingRight={12}
    whiteSpace="nowrap"
    href={externalLinks.sessionLanding}
    as={Link}
  >
    Visit Sessionstudio.com
  </Text>
);
